import React from 'react';

// Portrait (9:16) clips shown in matching 9:16 frames so they fill edge-to-edge, no letterboxing.
export default function PortraitVideoGallery({ videos, accent }) {
  return (
    <div className="flex gap-5 overflow-x-auto snap-x snap-mandatory pb-2 sm:grid sm:grid-cols-3 sm:overflow-visible max-w-4xl" data-testid="portrait-video-gallery">
      {videos.map((src, i) => (
        <div
          key={src}
          data-testid={`portrait-video-${i + 1}`}
          className="relative shrink-0 w-[70vw] sm:w-auto snap-center aspect-[9/16] rounded-2xl overflow-hidden border border-white/10"
          style={{ boxShadow: `0 30px 70px -30px ${accent || 'rgb(var(--brand-rgb))'}` }}
        >
          <video src={src} controls playsInline preload="metadata" className="absolute inset-0 w-full h-full object-cover" />
        </div>
      ))}
    </div>
  );
}
